import React from "react";
import { Icon } from "antd";

export function replacer(name) {
  // Refactoring is required. removing spaces and appending "_"
  return name.split(" ").join("_");
}

export function retrieveName(name) {
  // Refactoring is required. removing underscore with space
  return name.split("_").join(" ");
}

export function formatInput(value) {
  // Append $ symbol at the starting of the string

  const replacedVal = `${value}`.replace(/^\.|[^0-9.]/g, "");
  const regExp = /(^[^.]*\.[^.]*)(\..*)/g;
  const captureArr = regExp.exec(`${replacedVal}`);
  if (captureArr) {
    return captureArr[1];
  }
  const index = replacedVal.indexOf(".");
  let replacedValNew;
  if (index !== -1 && index + 3 === replacedVal.length - 1) {
    replacedValNew = replacedVal.slice(0, -1);
  } else {
    replacedValNew = replacedVal;
  }
  return replacedValNew.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function plainValue(value) {
  return value
    .split(",")
    .join("")
    .replace("$", "");
}

export function formatPercent(value) {
  // Handles the Percentage Input Box
  const replacedVal = `${value}`.replace(/^\.|[^0-9.]/g, "");
  const regExp = /(^[^.]*\.[^.]*)(\..*)/g;
  const captureArr = regExp.exec(`${replacedVal}`);
  // If the match fails, the exec() method returns null.

  let formattedVal;
  if (captureArr) {
    // return function with value in first capture group
    formattedVal = captureArr[1];
  }
  formattedVal = replacedVal;

  if (/[0-9]/.test(formattedVal)) {
    const truncatedPercentage = `${formattedVal}`.replace(/\..*/, "");
    // Handle delete event
    // Replace the digit before % -> (\d|\.)(?=%), with ''.
    // (or)
    // Replace value containing only one digit followed by % -> (^\d%$), with ''.
    return `${truncatedPercentage}%`;
  }
}

export function formatPercentOnBlur(value) {
  // Adds % at the end of the
  return `${value}`;
}

export function dollarText(value) {
  if (value == 0) {
    return <>&mdash;</>;
  }
  const decValue = parseFloat(value).toFixed(2);
  const replacedVal = `${decValue}`.replace(/^\.|[^0-9.]/g, "");
  const regExp = /(^[^.]*\.[^.]*)(\..*)/g;
  const captureArr = regExp.exec(`${replacedVal}`);
  if (captureArr) {
    return captureArr[1];
  }
  const index = replacedVal.indexOf(".");
  let replacedValNew;
  if (index !== -1 && index + 3 === replacedVal.length - 1) {
    replacedValNew = replacedVal.slice(0, -1);
  } else {
    replacedValNew = replacedVal;
  }
  return `$ ${replacedValNew.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;
}

function raiseOrDown(status) {
  if (status === true) {
    return <Icon type="caret-up" />;
  } else if (status === false) {
    return <Icon type="caret-down" />;
  }
}

export function unitText(value) {
  if (value == 0) {
    return <>&mdash;</>;
  }
  const decValue = parseFloat(value).toFixed(4);
  const replacedVal = `${decValue}`.replace(/^\.|[^0-9.]/g, "");
  const regExp = /(^[^.]*\.[^.]*)(\..*)/g;
  const captureArr = regExp.exec(`${replacedVal}`);
  if (captureArr) {
    return captureArr[1];
  }
  const index = replacedVal.indexOf(".");
  let replacedValNew;
  if (index !== -1 && index + 5 === replacedVal.length - 1) {
    replacedValNew = replacedVal.slice(0, -1);
  } else {
    replacedValNew = replacedVal;
  }
  // return `${replacedValNew.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;
  return `${replacedValNew}`;
}

export function pricePerUnitText(value, status) {
  if (value == 0) {
    return <>&mdash;</>;
  }
  const decValue = parseFloat(value).toFixed(2);
  const replacedVal = `${decValue}`.replace(/^\.|[^0-9.]/g, "");
  const regExp = /(^[^.]*\.[^.]*)(\..*)/g;
  const captureArr = regExp.exec(`${replacedVal}`);
  if (captureArr) {
    return captureArr[1];
  }
  const index = replacedVal.indexOf(".");
  let replacedValNew;
  if (index !== -1 && index + 3 === replacedVal.length - 1) {
    replacedValNew = replacedVal.slice(0, -1);
  } else {
    replacedValNew = replacedVal;
  }
  const pricePerUNit = `$${replacedValNew.replace(
    /\B(?=(\d{3})+(?!\d))/g,
    ","
  )}`;
  return (
    <div>
      {pricePerUNit}
      {raiseOrDown(status)}
    </div>
  );
}

export function replaceSelect(value){
  return value && value.replace(' Select', '');
}